import { useMemo, useState } from 'react';
import { CurrencyIcon } from '~/components/collections';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Switch } from '~/components/ui/Switch';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { rage, useObservable } from '~/rage';
import { Currency } from '~/shared';
import { AdsStages } from '../../models/Ads';
import { setActiveAdsState, useLayoutDispatch } from '../../redux';
import { AppBackButton } from '../AppBackButton';
import {
	StyledAsapOption,
	StyledContainer,
	StyledHead,
	StyledOptionsContainer,
	StyledPriceContainer,
	StyledTextArea,
	StyledTextAreaContainer,
	StyledTextAreaStatsContainer,
} from './AppAdsCreate.styles';

const AppAdsCreate = () => {
	const dispatch = useLayoutDispatch();
	const adsSettings = useObservable(rage.ads.getAdsSettings());
	// TODO: add sdk
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [isPhoneOption, setIsPhoneOption] = useState(false);
	const [isAsapOption, setIsAsapOption] = useState(false);
	const [textAreaValue, setTextAreaValue] = useState('');
	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	const maxLength = adsSettings?.maxTextLength ?? 300;
	const publicationPrice = adsSettings?.slowQueuePrice ?? 10_000;
	const urgentPrice = adsSettings?.fastQueuePrice ?? 5_000;

	const totalPrice = useMemo(
		() => publicationPrice + (isAsapOption ? urgentPrice : 0),
		[publicationPrice, urgentPrice, isAsapOption],
	);

	const handleBack = () => {
		dispatch(setActiveAdsState(AdsStages.LIVE));
	};

	const handleTextChange = (value: string) => {
		setTextAreaValue(value.slice(0, maxLength));
	};

	const canSubmit = textAreaValue.trim().length > 0;

	const handleSubmit = async () => {
		if (!canSubmit) {
			return;
		}

		try {
			await rage.ads.createAd(
				textAreaValue.trim(),
				isPhoneOption,
				isAsapOption,
			);
			dispatch(setActiveAdsState(AdsStages.LIVE));
		} catch (err) {
			rage.notifications.showException(err);
		}
	};

	return (
		<div>
			<StyledHead>
				<AppBackButton onClick={handleBack} />
				<Text>Новое объявление</Text>
			</StyledHead>
			<StyledContainer>
				<StyledOptionsContainer>
					{/* <StyledPhoneOption>
						<Text style={{ fontSize: 14, fontWeight: 500, color: '#ffffff' }}>
							Оставить телефон
						</Text>
						<Switch value={isPhoneOption} onChange={setIsPhoneOption} />
					</StyledPhoneOption> */}
					<StyledAsapOption>
						<Text style={{ fontSize: 14, fontWeight: 500, color: '#ffffff' }}>
							Срочная подача
						</Text>
						<Text
							style={{
								fontSize: 14,
								fontWeight: 500,
								color: '#ffffff',
								opacity: 0.5,
							}}
						>
							+ ₽ {urgentPrice.toLocaleString('ru-RU')}
						</Text>
						<Switch value={isAsapOption} onChange={setIsAsapOption} />
					</StyledAsapOption>
				</StyledOptionsContainer>
				<StyledTextAreaContainer>
					<StyledTextArea
						placeholder="Введите текст сообщения"
						value={textAreaValue}
						onChange={(e) => handleTextChange(e.target.value)}
					/>
					<StyledTextAreaStatsContainer>
						<Text style={{ fontSize: 14, color: 'rgba(255, 255, 255, 0.25)' }}>
							<span
								style={{ color: 'rgba(255, 255, 255, 0.5)', fontWeight: 500 }}
							>
								{textAreaValue.length}
							</span>{' '}
							/ {maxLength}
						</Text>
					</StyledTextAreaStatsContainer>
				</StyledTextAreaContainer>
				<StyledPriceContainer>
					<Text style={{ fontSize: 16, color: '#ffffff', opacity: 0.25 }}>
						Сумма к оплате
					</Text>
					<Text style={{ fontSize: 16, color: '#ffffff', fontWeight: 700 }}>
						{totalPrice.toLocaleString('ru-RU')}
					</Text>
					<CurrencyIcon
						icon={rubleIcon}
						size="sm"
						style={{ opacity: 0.5, marginTop: 2 }}
					/>
				</StyledPriceContainer>
				<Button
					color={ButtonColors.Buy}
					height={ButtonHeight.Height60}
					disabled={!canSubmit}
					style={{ fontSize: 18 }}
					onClick={handleSubmit}
				>
					<Text>
						{!canSubmit ? 'Введите текст объявления' : 'Оплатить и отправить'}
					</Text>
				</Button>
			</StyledContainer>
		</div>
	);
};

export { AppAdsCreate };
